import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EndUserStateService {
  private user = new BehaviorSubject<CaseStakeholder>(undefined);

  constructor() {}

  public sendEndUser(newUser: CaseStakeholder) {
    this.user.next(newUser);
  }

  // caution: this could be an end user from another case, check .caseId attribute of returned object
  public getEndUser(): Observable<CaseStakeholder> {
    return this.user.asObservable();
  }

}
